export const STRIPE_PAYMENT_SOURCE = 'stripe';
export const LIQ_PAY_PAYMENT_SOURCE = 'liqPay';
export const WAY_FOR_PAY_PAYMENT_SOURCE = 'wayForPay';
